<template>
    <div class="thead flex start vcenter">
        <Checkbox @onclick="all = !all" :vm="all"></Checkbox>
        <div v-if="(Number(data.entity?.properties?.['PROCESS'] || '0') || 0) > 0"
            class="situation flex wrap center vcenter">
            <p>{{ 'آخرین موقعیت' }}</p>
            <span class="tooltip">{{ 'آخرین موقعیت' }}</span>
        </div>
        <template v-for="(meta, index) in data.metas" :key="index">
            <div v-show="data.visibilities[meta.key] === 'visible'" class="flex wrap center vcenter"
                :class="[{ 'override': base.Entities().parse(meta.extras)['column'] }, { 'order': `[${meta.key}]` === this.data?.order }]"
                :style="{
                    'width': base.Entities().parse(meta.extras)['column']
                        || (meta.style ? JSON.parse(meta.style)['width'] : '')
                }" @click.prevent="order(meta.key)">
                <p>{{ value = base.Entities().parse(meta.extras)['name'] || meta.name }}</p>
                <span class=" tooltip">{{ value }}</span>
                <i v-if="`[${meta.key}]` === this.data?.order" class="fe fe-16"
                    :class="[{ 'fe-chevron-up': this.data?.direction === 'ASC' }, { 'fe-chevron-down': this.data?.direction === 'DESC' }]"></i>
            </div>
        </template>
        <div v-if="data.visibilities['created_at']" class="created_at flex wrap center vcenter"
            :class="{ 'order': '[created_at]' === this.data?.order }" @click.prevent="order('created_at')">
            <p>{{ data.entity?.properties['CREATED_AT_TITLE'] || 'تاریخ ثبت' }}</p>
            <span class="tooltip">{{ data.entity?.properties['CREATED_AT_TITLE'] || 'تاریخ ثبت' }}</span>
            <i v-if="'[created_at]' === this.data?.order" class="fe fe-16"
                :class="[{ 'fe-chevron-up': this.data?.direction === 'ASC' }, { 'fe-chevron-down': this.data?.direction === 'DESC' }]"></i>
        </div>
        <div v-if="data.visibilities['status']" class="status flex wrap center vcenter"
            :class="{ 'order': '[status]' === this.data?.order }" @click.prevent="order('status')">
            <p>{{ data.entity?.properties['STATUS_TITLE'] || 'وضعیت' }}</p>
            <span class="tooltip">{{ data.entity?.properties['STATUS_TITLE'] || 'وضعیت' }}</span>
            <i v-if="'[status]' === this.data?.order" class="fe fe-16"
                :class="[{ 'fe-chevron-up': this.data?.direction === 'ASC' }, { 'fe-chevron-down': this.data?.direction === 'DESC' }]"></i>
        </div>
        <div v-if="data.visibilities['shield']" class="shield">
        </div>
        <div v-if="data.visibilities['operations']" class="operations">
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Checkbox from '../Form/Inputs/Checkbox.vue'

export default {
    name: 'THead',
    props: ['entity_type', 'page', 'size', 'data'],
    inject: ['base'],
    components: { Checkbox },
    data() {
        return {
            all: false
        }
    },
    watch: {
        data: {
            handler(newData, oldData) {
                this.all = (this.data.selected.length === Number(this.size) || this.data.selected.length === this.data.count) && this.data.count > 0
            },
            deep: true
        },
        all(newAll, oldAll) {
            this.$emit('onchange', {
                count: this.data.count,
                selected: this.all || (this.data.selected.length !== Number(this.size) && this.data.selected.length !== this.data.count)
                    ? this.data.selected
                    : [],
                all: this.all
            })
        }
    },
    methods: {
        order(key) {
            this.$emit('onorder', {
                order: `[${key}]`,
                direction: this.data?.order === `[${key}]`
                    ? this.data?.direction === 'ASC'
                        ? 'DESC'
                        : 'ASC'
                    : 'DESC'
            })
        }
    }
}
</script>